export default "__VITE_ASSET__B1Gz100f__"